import React from "react"
import { useNavigate } from "react-router-dom"
import { makeStyles, Theme, Paper } from "@material-ui/core"
import useAppState from "hooksV1/useAppState"

type DocumentCardProps = {
  documentId: string
  documentName: string
  documentVersion: number
}

const useStyles = makeStyles((theme: Theme) => ({
  documentPaper: {
    display: "flex",
    height: "10vw",
    minHeight: "120px", // Minimum height to ensure readability
    width: "10vw",
    minWidth: "120px", // Minimum width to ensure readability
    borderRadius: "10px",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between", // Better space distribution
    padding: theme.spacing(1),
    transition: "transform 0.3s ease, background-color 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      backgroundColor: theme.palette.action.hover,
    },
    cursor: "pointer",
    overflow: "hidden", // Prevent content from overflowing
  },
  titleTextTypography: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    flex: 1,
    padding: theme.spacing(0.5),
  },
  documentName: {
    margin: 0,
    fontSize: "1rem",
    fontFamily: "Lato",
    letterSpacing: "0.08rem",
    marginTop: "0.2rem",
    width: "100%",
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limit to 2 lines
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "1.2", // Adjust line height for better readability
    maxHeight: "2.4em", // Approximate height for 2 lines (1.2em line height × 2)
  },
  versionText: {
    display: "flex",
    justifyContent: "center",
    fontSize: "13px",
    marginBottom: "0.3rem",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}))

const DocumentCard: React.FC<DocumentCardProps> = ({
  documentId,
  documentName,
  documentVersion,
}) => {
  const classes = useStyles()
  const { activeCountry, documents, setActiveDocument } = useAppState()
  const navigate = useNavigate()
  const pathArray = location.pathname.split("/")
  const projectId = pathArray[2]
  const country = activeCountry?.country_name ?? "Global"

  const openDocument = (documentId: string) => {
    navigate(`/project/${projectId}/document/${documentId}/country/${country}`)
    const activeDocument = documents?.find((doc) => doc.id === documentId)
    setActiveDocument(activeDocument)
  }

  return (
    <Paper
      elevation={2}
      className={classes.documentPaper}
      onClick={() => openDocument(documentId)}
    >
      <p className={classes.versionText}>Document:</p>

      <div className={classes.titleTextTypography}>
        <p className={classes.documentName} title={documentName}>
          {documentName}
        </p>
      </div>
      <p
        className={classes.versionText}
        title={`Working Version: ${documentVersion}`}
      >
        Working Version: {documentVersion}
      </p>
    </Paper>
  )
}

export default DocumentCard
